module.exports = __webpack_public_path__ + "img/thumbnail_TasmanianDevil_m_normal.0a8d7969.png";